import { useSelector } from 'react-redux';
import { RootState } from '@store/types';

/*
 * Reads the Airflow-disabled feature flag that gates the whole dashboard
 */
export function useAirflowDashboard() {
    const { envVariables: Env } = useSelector((store: RootState) => store.AccountReducer);
    const isAirflowDisabled = Boolean(Env?.REACT_APP_DISABLE_AIRFLOW);

    return { isAirflowDisabled };
}
